import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'li';


register('wm-nav-item', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          return `<${tagName} wmNavItem wmsTransclude role="listitem"  ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
